import React, { useState } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import ContactOut from './pages/ContactOut';
import Passwords from './pages/Passwords';
import Banking from './pages/Banking';
import EndowmentCentre from './pages/EndowmentCentre';
import Blockchain from './pages/Blockchain';
import { FileProvider } from './contexts/FileContext';
import Files from './pages/Files';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import PaymentVerificationPage from './pages/PaymentVerificationPage';
import NotFound from './pages/NotFound';
import CheckoutSuccess from './pages/CheckoutSuccess';
import ReceivedEndowment from './pages/ReceivedEndowment';
import Gift from './pages/Gift';
import { paypalOptions } from './utils/constants';
import { UploadQueueProvider } from './contexts/UploadQueueContext';
import GlobalUploadQueue from './components/GlobalUploadQueue';
import FAQout from './pages/FAQ-out';
import FAQ from './pages/FAQ';
import ModalTest from './pages/ModalTest';
import PageViewTracker from './PageViewTracker';
import CryptoConfessions from './pages/CryptoConfessions';

import { AdminProvider } from './contexts/AdminContext';
import AdminPanel from './pages/admin/AdminPanel';

// Import your Web3Provider
import Web3Provider from './providers/Web3Provider';

function App() {
  return (
    <Web3Provider>
      <PayPalScriptProvider options={paypalOptions}>
        <Router>
          <AuthProvider>
            <div className="app">
              <main className="main-content">
                <UploadQueueProvider>
                  <PageViewTracker />
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/contact-us" element={<ContactOut />} />
                    <Route path="/received" element={<ReceivedEndowment />} />
                    <Route path="/gift" element={<Gift />} />
                    <Route path="/faq-out" element={<FAQout />} />
                    <Route path="/modal" element={<ModalTest />} />
                    <Route path="/cryptoconfessions" element={<CryptoConfessions />} />
                    <Route path="/payment-verification/:token" element={<PaymentVerificationPage />} />

                    {/* Admin routes */}
                    <Route
                      path="/admin/*"
                      element={
                        <AdminProvider>
                          <AdminPanel />
                        </AdminProvider>
                      }
                    />

                    {/* Protected routes */}
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-files"
                      element={
                        <ProtectedRoute>
                          <FileProvider>
                            <Files />
                          </FileProvider>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-passwords"
                      element={
                        <ProtectedRoute>
                          <Passwords />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-banking"
                      element={
                        <ProtectedRoute>
                          <Banking />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/my-blockchain"
                      element={
                        <ProtectedRoute>
                          <Blockchain />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/endowment-centre"
                      element={
                        <ProtectedRoute>
                          <EndowmentCentre />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/profile"
                      element={
                        <ProtectedRoute>
                          <Profile />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="/checkout-success" element={<CheckoutSuccess />} />
                    <Route
                      path="/contact"
                      element={
                        <ProtectedRoute>
                          <Contact />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/faq"
                      element={
                        <ProtectedRoute>
                          <FAQ />
                        </ProtectedRoute>
                      }
                    />

                    {/* Catch-all route for 404 pages */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                  <GlobalUploadQueue />
                </UploadQueueProvider>
              </main>
            </div>
          </AuthProvider>
        </Router>
      </PayPalScriptProvider>
    </Web3Provider>
  );
}

export default App;